(function () {
  'use strict';

  var T = window.ornT || {};

  var QUICK_LINKS = [
    { title: T.palette_ql_schedule_title || 'Send a plant schedule', url: '/pages/contact-us', hint: T.palette_ql_schedule_hint || 'Start a project enquiry' },
    { title: T.palette_ql_stock_title || 'All stock references', url: '/collections/all', hint: T.palette_ql_stock_hint || '1,400+ species' },
    { title: T.palette_ql_collections_title || 'Browse collections', url: '/pages/all-categories', hint: T.palette_ql_collections_hint || 'Category index' },
    { title: T.palette_ql_projects_title || 'Projects track record', url: '/pages/projects', hint: T.palette_ql_projects_hint || 'Disney, Red Sea, Qiddiya' },
    { title: T.palette_ql_archive_title || 'Knowledge Archive', url: '/blogs/archive', hint: T.palette_ql_archive_hint || 'Company records since the 1990s' },
    { title: T.palette_ql_delivery_title || 'Delivery and export', url: '/pages/delivery', hint: T.palette_ql_delivery_hint || 'Air, sea and land freight' },
    { title: T.palette_ql_accreditations_title || 'Accreditations', url: '/pages/accreditations', hint: T.palette_ql_accreditations_hint || 'MEWA, export registration' },
    { title: T.palette_ql_news_title || 'News and guides', url: '/blogs/news', hint: T.palette_ql_news_hint || 'Planting intelligence' }
  ];

  var overlay = null;
  var input = null;
  var list = null;
  var items = [];
  var activeIndex = -1;
  var timer = null;
  var lastFocus = null;

  function build() {
    if (overlay) return;
    overlay = document.createElement('div');
    overlay.className = 'orpal-overlay';
    overlay.hidden = true;
    overlay.innerHTML =
      '<div class="orpal-panel" role="dialog" aria-modal="true" aria-label="' + esc(T.palette_dialog_label || 'Site navigator') + '">' +
      '<input class="orpal-input" type="text" placeholder="' + esc(T.palette_placeholder || 'Search species, pages, projects...') + '" aria-label="' + esc(T.palette_input_label || 'Search the site') + '" autocomplete="off">' +
      '<div class="orpal-list" role="listbox"></div>' +
      '<div class="orpal-hint"><span><kbd>&#8593;</kbd><kbd>&#8595;</kbd> ' + esc(T.palette_key_navigate || 'navigate') + '</span><span><kbd>Enter</kbd> ' + esc(T.palette_key_open || 'open') + '</span><span><kbd>Esc</kbd> ' + esc(T.palette_key_close || 'close') + '</span></div>' +
      '</div>';
    document.body.appendChild(overlay);
    input = overlay.querySelector('.orpal-input');
    list = overlay.querySelector('.orpal-list');

    overlay.addEventListener('mousedown', function (e) {
      if (e.target === overlay) close();
    });
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { renderQuick(); return; }
      timer = setTimeout(function () { search(q); }, 200);
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); move(1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); move(-1); }
      else if (e.key === 'Enter') {
        e.preventDefault();
        var target = items[activeIndex] || items[0];
        if (target) window.location.href = target.getAttribute('href');
      } else if (e.key === 'Escape') { close(); }
    });
    renderQuick();
  }

  function collectItems() {
    items = Array.prototype.slice.call(list.querySelectorAll('.orpal-item'));
    activeIndex = items.length ? 0 : -1;
    paint();
  }

  function paint() {
    for (var i = 0; i < items.length; i++) {
      items[i].classList.toggle('is-active', i === activeIndex);
    }
    if (items[activeIndex]) {
      items[activeIndex].scrollIntoView({ block: 'nearest' });
    }
  }

  function move(delta) {
    if (!items.length) return;
    activeIndex = (activeIndex + delta + items.length) % items.length;
    paint();
  }

  function section(label) {
    return '<div class="orpal-section">' + label + '</div>';
  }

  function esc(s) {
    return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function itemHtml(url, title, hint, img) {
    return '<a class="orpal-item" href="' + esc(url) + '" role="option">' +
      (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="36" height="36">' : '') +
      '<span class="orpal-item__body"><span class="orpal-item__title">' + esc(title) + '</span>' +
      (hint ? '<span class="orpal-item__hint">' + esc(hint) + '</span>' : '') + '</span></a>';
  }

  function renderQuick() {
    var html = section(T.palette_section_quick_links || 'Quick links');
    for (var i = 0; i < QUICK_LINKS.length; i++) {
      html += itemHtml(QUICK_LINKS[i].url, QUICK_LINKS[i].title, QUICK_LINKS[i].hint, null);
    }
    list.innerHTML = html;
    bindClicks();
    collectItems();
  }

  function search(q) {
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product,page,article&resources[limit]=5';
    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var res = (d.resources && d.resources.results) || {};
        var html = '';
        var products = res.products || [];
        var pages = res.pages || [];
        var articles = res.articles || [];
        if (products.length) {
          html += section(T.palette_section_species || 'Species');
          for (var i = 0; i < products.length; i++) {
            var p = products[i];
            var img = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
            if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=72';
            html += itemHtml(p.url, p.title, null, img);
          }
        }
        if (pages.length) {
          html += section(T.palette_section_pages || 'Pages');
          for (var j = 0; j < pages.length; j++) {
            html += itemHtml(pages[j].url, pages[j].title, null, null);
          }
        }
        if (articles.length) {
          html += section(T.palette_section_articles || 'Articles and records');
          for (var k = 0; k < articles.length; k++) {
            html += itemHtml(articles[k].url, articles[k].title, null, null);
          }
        }
        if (!html) {
          html = '<div class="orpal-empty">' +
            esc(T.palette_empty || 'No matches. Try a botanical name, or send your schedule via {link}.')
              .replace('{link}', '<a href="/pages/contact-us">' + esc(T.palette_empty_link || 'the enquiry page') + '</a>') +
            '</div>';
        }
        list.innerHTML = html;
        bindClicks();
        collectItems();
      })
      .catch(function () {});
  }

  function bindClicks() {
    var links = list.querySelectorAll('.orpal-item');
    for (var i = 0; i < links.length; i++) {
      links[i].addEventListener('mousemove', function (e) {
        var idx = items.indexOf(e.currentTarget);
        if (idx > -1 && idx !== activeIndex) { activeIndex = idx; paint(); }
      });
    }
  }

  function open() {
    build();
    lastFocus = document.activeElement;
    overlay.hidden = false;
    document.documentElement.classList.add('orpal-lock');
    input.value = '';
    renderQuick();
    input.focus();
  }

  function close() {
    if (!overlay) return;
    overlay.hidden = true;
    document.documentElement.classList.remove('orpal-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('keydown', function (e) {
    if ((e.metaKey || e.ctrlKey) && (e.key === 'k' || e.key === 'K')) {
      e.preventDefault();
      if (overlay && !overlay.hidden) { close(); } else { open(); }
    }
  });

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest ? e.target.closest('[data-orpal-open]') : null;
    if (trigger) { e.preventDefault(); open(); }
  });
})();
